module.exports = __webpack_public_path__ + "img/p124.f9192af7.jpg";